import { useMeasure } from 'react-use';
import Popovers from '../../components/bootstrap/Popovers';

const Footer = () => {
	const [ref, { height }] = useMeasure<HTMLDivElement>();

	const root = document.documentElement;
	root.style.setProperty('--footer-height', `${height}px`);

	const projectName = process.env.REACT_APP_PROJECT_NAME;
	const currentYesr = new Date().getFullYear();

	return (
		<footer ref={ref} className='footer'>
			<div className='container-fluid'>
				<div className='row'>
					<div className='col'>
						<Popovers>
							<p>
								{projectName} @{currentYesr}
							</p>
						</Popovers>
					</div>
					<div className='col-auto'>
						<Popovers>
							<p>{projectName} Team</p>
						</Popovers>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
